"use client";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { useEffect, useState, useRef } from "react";
import ErrorBoundary from "./ErrorBoundary";
import React from "react";
import { Spinner } from 'flowbite-react';

function PdfPage({ fileUrl, scale }) {
  const zoomScale = useRef(scale);
  const [isCalculated, setIsCalculated] = useState(false);
  useEffect(() => {
    // console.log(window.innerWidth);
    zoomScale.current = window.matchMedia("(max-width:770px)").matches
      ? 0.6
      : scale;
    setIsCalculated(true);
    return () => {};
  }, [scale]);

  // defaultScale={SpecialZoomLevel.PageFit}
  return isCalculated ? (
    <ErrorBoundary>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
        <Viewer
          theme="dark"
          defaultScale={zoomScale.current}
          fileUrl={fileUrl}
        />
      </Worker>
    </ErrorBoundary>
  ):(<Spinner size="md"/>);
}

export default PdfPage;
